import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "contexts/AuthContext";
import FullPageSpinner from "components/auth/FullPageSpinner";

// Inverse of ProtectedRoute: keeps an already authenticated user out of the
// sign-in screen, and sends them back where they came from if they arrived via
// a protected link.
export default function GuestRoute() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <FullPageSpinner />;

  if (user) {
    const target = location.state?.from?.pathname || "/";
    return <Navigate to={target} replace />;
  }

  return <Outlet />;
}
